import React from "react";
import { X, Lock } from "lucide-react";
import { formatCell } from "./format";

// Every field of one record, with its type and meaning.
export default function RowDetail({ row, columns, masked, onClose }) {
  if (!row) return null;
  return (
    <aside data-testid="dt-row-detail" className="fixed inset-y-0 right-0 w-full sm:w-[420px] bg-surface border-l border-border shadow-2xl z-[60] flex flex-col animate-slide-in-right">
      <div className="flex items-start justify-between gap-3 px-4 py-3 border-b border-border">
        <div className="min-w-0">
          <div className="text-[10px] uppercase tracking-[0.22em] text-primary font-semibold">Record detail · row key</div>
          <div className="font-mono-tabular text-[13px] font-semibold truncate" data-testid="dt-row-detail-key">{row._rid}</div>
        </div>
        <button type="button" data-testid="dt-row-detail-close" onClick={onClose}
                className="w-8 h-8 inline-flex items-center justify-center border border-border hover:border-primary hover:text-primary rounded-sm shrink-0"><X size={14} /></button>
      </div>
      <dl className="flex-1 overflow-y-auto divide-y divide-border/70">
        {columns.map(c => (
          <div key={c.key} data-testid={`dt-field-${c.key}`} className="px-4 py-2.5 grid grid-cols-[minmax(0,1fr)_minmax(0,1.3fr)] gap-3">
            <dt className="min-w-0">
              <div className="font-mono-tabular text-[11px] font-semibold truncate">{c.key}</div>
              <div className="text-[10px] text-subtle uppercase tracking-widest">{c.type}{c.pii ? " · personal" : ""}</div>
              {c.description && <div className="text-[10.5px] text-muted leading-snug mt-0.5">{c.description}</div>}
            </dt>
            <dd className="font-mono-tabular text-[12px] break-words flex items-start gap-1.5">
              {c.pii && masked && <Lock size={11} className="text-warning mt-0.5 shrink-0" />}
              <span data-testid={`dt-field-${c.key}-value`}>{formatCell(c, row[c.key])}</span>
            </dd>
          </div>
        ))}
      </dl>
      {masked && columns.some(c => c.pii) && (
        <div data-testid="dt-row-detail-masked-note" className="px-4 py-2.5 border-t border-border text-[11px] text-muted">Personal details are masked — only the IT Head sees them in full.</div>
      )}
    </aside>
  );
}
